(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(c) { return window.BroatMoney ? window.BroatMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function packOf(title) {
    var t = String(title || '').toLowerCase().replace(/\s/g, '');
    var n = t.split('+').reduce(function (a, p) { return a + (parseInt(p.split('x')[0], 10) || 0); }, 0);
    return n > 0 ? n : 1;
  }
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var d = root.dataset;
    var tiers = String(d.tiers || '').split(',').map(function (x) { var p = x.split('-'); return { value: parseFloat(p[0]) || 0, qty: parseInt(p[1], 10) || 0 }; })
      .filter(function (x) { return x.value > 0 && x.qty > 0; }).sort(function (x, y) { return x.value - y.value; });
    var cfg = { key: d.key, tiers: tiers, min: parseFloat(d.min) || 0, max: parseInt(d.max, 10) || 0, packs: d.packs === '1' };
    var topValue = tiers.length ? tiers[tiers.length - 1].value : cfg.min;
    var track = root.querySelector('[data-bb-track]');
    if (track && topValue > 0) {
      tiers.slice(0, -1).forEach(function (tr) {
        var tick = document.createElement('i');
        tick.style.left = (tr.value / topValue * 100) + '%';
        track.appendChild(tick);
      });
    }
    var items = Array.prototype.map.call(root.querySelectorAll('[data-bb-item]'), function (el) {
      var variants = JSON.parse(el.querySelector('[data-bb-variants]').textContent);
      var sel = el.querySelector('[data-bb-variant]');
      return { el: el, role: el.dataset.role, variants: variants, select: sel, qty: 0, limit: parseInt(el.dataset.limit, 10) || 0 };
    });
    function variantOf(it) {
      var id = it.select ? it.select.value : String(it.variants[0] && it.variants[0].id);
      return it.variants.filter(function (v) { return String(v.id) === String(id); })[0] || it.variants[0];
    }
    function totals() {
      var count = 0, sum = 0, addon = 0, addonSum = 0;
      items.forEach(function (it) {
        var v = variantOf(it); if (!v) return;
        if (it.role === 'main') { count += it.qty * (cfg.packs ? packOf(v.title) : 1); sum += it.qty * v.price; }
        else { addon += it.qty; addonSum += it.qty * v.price; }
      });
      return { count: count, sum: sum, addon: addon, addonSum: addonSum };
    }
    function allowed(t) {
      var a = 0;
      if (t.sum < cfg.min) return 0;
      cfg.tiers.forEach(function (tr) { if (t.sum >= tr.value && tr.qty > a) a = tr.qty; });
      return a;
    }
    function render() {
      var t = totals(), a = allowed(t);
      // Add-ons kürzen, wenn die Bedingung nicht mehr reicht
      if (t.addon > a) {
        var over = t.addon - a;
        items.filter(function (it) { return it.role === 'addon'; }).reverse().forEach(function (it) {
          var cut = Math.min(it.qty, over); it.qty -= cut; over -= cut;
        });
        t = totals();
      }
      items.forEach(function (it) {
        var v = variantOf(it);
        var out = it.el.querySelector('[data-bb-qty]');
        if (out) out.textContent = it.qty;
        it.el.classList.toggle('is-selected', it.qty > 0);
        var price = it.el.querySelector('[data-bb-price]');
        if (price && v) price.textContent = money(v.price);
        var minus = it.el.querySelector('[data-bb-step="-1"]'), plus = it.el.querySelector('[data-bb-step="1"]');
        if (minus) minus.disabled = it.qty < 1;
        var canAdd = v && v.available;
        if (it.limit && it.qty >= it.limit) canAdd = false;
        if (it.role === 'addon' && t.addon >= a) canAdd = false;
        if (it.role === 'main' && cfg.max > 0) {
          var step = cfg.packs ? packOf(v && v.title) : 1;
          if (t.count + step > cfg.max) canAdd = false;
        }
        if (plus) plus.disabled = !canAdd;
        var sold = it.el.querySelector('[data-bb-sold]');
        if (sold) sold.hidden = !!(v && v.available);
      });
      var step = root.querySelector('[data-bb-addon-step]');
      if (step) {
        var unlocked = a > 0;
        step.classList.toggle('is-locked', !unlocked);
        var bar = root.querySelector('[data-bb-bar]');
        if (bar) bar.style.width = (topValue > 0 ? Math.min(100, t.sum / topValue * 100) : 100) + '%';
        var next = cfg.tiers.filter(function (tr) { return t.sum < tr.value; })[0];
        var text = root.querySelector('[data-bb-progress-text]');
        if (text) {
          var msg = '';
          if (unlocked) msg = (d.tDone || '').replace('[anzahl]', a).replace('[gewaehlt]', t.addon);
          if (next) {
            var tpl = unlocked ? (d.tNext || '') : (d.tProgress || '');
            msg += (msg ? ' ' : '') + tpl.replace('[rest]', money(next.value - t.sum)).replace('[anzahl]', next.qty);
          }
          text.textContent = msg;
        }
      }
      function setAll(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
      var countText = t.count + ' ' + (d.tUnit || '') + (t.addon > 0 ? ' + ' + (d.tAddon || '').replace('[anzahl]', t.addon) : '');
      setAll('[data-bb-count]', function (el) { el.textContent = countText; });
      setAll('[data-bb-total]', function (el) { el.textContent = money(t.sum + t.addonSum); });
      var ok = t.count > 0 && t.sum >= cfg.min;
      setAll('[data-bb-submit]', function (el) { el.disabled = !ok; });
      var hintText = (ok || cfg.min <= 0) ? '' : (d.tMin || '').replace('[betrag]', money(cfg.min)).replace('[rest]', money(Math.max(0, cfg.min - t.sum)));
      setAll('[data-bb-hint]', function (el) { el.textContent = hintText; });
      var list = root.querySelector('[data-bb-list]');
      if (list) {
        list.innerHTML = '';
        items.forEach(function (it) {
          if (it.qty < 1) return;
          var v = variantOf(it); if (!v) return;
          var li = document.createElement('li');
          var name = document.createElement('span');
          var title = it.el.querySelector('.bb-card__title');
          name.textContent = it.qty + '× ' + (title ? title.textContent.trim() : '') + (v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '');
          var price = document.createElement('span');
          price.textContent = money(it.qty * v.price);
          li.appendChild(name); li.appendChild(price);
          if (it.role === 'addon') li.className = 'is-addon';
          list.appendChild(li);
        });
        var empty = root.querySelector('[data-bb-empty]');
        if (empty) empty.hidden = list.children.length > 0;
      }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bb-step]');
      if (b) {
        var el = b.closest('[data-bb-item]');
        var it = items.filter(function (x) { return x.el === el; })[0];
        if (!it) return;
        it.qty = Math.max(0, it.qty + parseInt(b.dataset.bbStep, 10));
        render();
        return;
      }
      var submit = e.target.closest('[data-bb-submit]');
      if (submit) {
        var t = totals();
        var rule = 'tiers:' + cfg.tiers.map(function (tr) { return tr.value + '-' + tr.qty; }).join(',') + ':' + cfg.min;
        var payload = [];
        items.forEach(function (it) {
          if (it.qty < 1) return;
          var v = variantOf(it); if (!v) return;
          var props = it.role === 'main' ? { _bundle: cfg.key } : { _bundle_addon: cfg.key, _bundle_rule: rule };
          props._bundle_name = d.name || '';
          props._bundle_url = window.location.pathname;
          payload.push({ id: v.id, quantity: it.qty, properties: props });
        });
        if (!payload.length || t.count < 1 || t.sum < cfg.min || !window.BroatCart) return;
        // Add-ons zuletzt, damit die Set-Artikel schon im Warenkorb liegen
        payload.sort(function (x, y) { return (x.properties._bundle_addon ? 1 : 0) - (y.properties._bundle_addon ? 1 : 0); });
        window.BroatCart.addItems(payload, submit, cfg.key).then(function (ok) {
          if (!ok) return;
          items.forEach(function (it) { it.qty = 0; });
          render();
        });
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-bb-variant]')) render();
    });
    render();
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-bundle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function find(target) {
    if (!target) return null;
    var el = document.getElementById(target);
    if (!el) {
      try { el = document.querySelector('[id^="shopify-section-"][id$="__' + (window.CSS && CSS.escape ? CSS.escape(target) : target) + '"]'); } catch (e) { el = null; }
    }
    return el;
  }
  function init(nav) {
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var header = document.querySelector('.site-header');
    var main = document.querySelector('[id^="shopify-section-"][id$="__main"]');
    var track = nav.querySelector('[data-pnav-track]');
    var items = [];
    function collect() {
      items = [];
      nav.querySelectorAll('[data-pnav-link]').forEach(function (a) {
        var el = find(a.dataset.pnavLink);
        var ok = el && el.offsetHeight > 100;
        a.hidden = !ok;
        if (ok) items.push({ a: a, el: el });
      });
      nav.hidden = items.length < 2;
    }
    collect();

    function headerBottom() {
      if (!header) return 0;
      var r = header.getBoundingClientRect();
      return Math.max(0, Math.round(r.bottom));
    }
    function setActive(item) {
      items.forEach(function (it) {
        var on = it === item;
        if (on) it.a.setAttribute('aria-current', 'true'); else it.a.removeAttribute('aria-current');
      });
      if (item && track.scrollWidth > track.clientWidth) {
        track.scrollTo({ left: item.a.offsetLeft - (track.clientWidth - item.a.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    var current = null, ticking = false;
    function update() {
      ticking = false;
      if (nav.hidden) return;
      var top = headerBottom();
      nav.style.top = top + 'px';
      var start = main ? main.getBoundingClientRect().bottom : items[0].el.getBoundingClientRect().top;
      var visible = start - top - nav.offsetHeight < 40;
      nav.classList.toggle('is-visible', visible);
      var line = top + nav.offsetHeight + 24, found = null;
      items.forEach(function (it) { if (it.el.getBoundingClientRect().top <= line) found = it; });
      if (found !== current) { current = found; setActive(found); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pnav-link]');
      if (!a) return;
      e.preventDefault();
      var it = items.filter(function (x) { return x.a === a; })[0];
      if (!it) return;
      var y = it.el.getBoundingClientRect().top + window.pageYOffset - headerBottom() - nav.offsetHeight - 8;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
    update();
    setTimeout(function () { collect(); update(); }, 2500);
    setTimeout(function () { collect(); update(); }, 6000);
  }
  function boot() { document.querySelectorAll('[data-pnav]').forEach(init); }
  if (document.readyState === 'complete') boot(); else window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function panelOf(el) { return el.closest('[data-ppanel]'); }
  function slides(track) { return Array.prototype.slice.call(track.children); }
  function current(track) {
    var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
    slides(track).forEach(function (el, i) {
      var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - mid);
      if (d < dist) { dist = d; best = i; }
    });
    return best;
  }
  function go(track, i) {
    var list = slides(track); if (!list.length) return;
    i = (i + list.length) % list.length;
    var el = list[i];
    track.scrollTo({ left: el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2, behavior: 'smooth' });
  }
  function buildDots(panel) {
    var track = panel.querySelector('[data-ptrack]'), dots = panel.querySelector('[data-pdots]'), ctrl = panel.querySelector('[data-pctrl]');
    if (!track || !dots) return;
    var n = track.children.length;
    if (ctrl) ctrl.classList.toggle('is-single', n < 2);
    if (dots.children.length !== n) {
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
    }
    var c = current(track);
    Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === c); });
  }
  function init(root) {
    (root || document).querySelectorAll('[data-ppanel]').forEach(buildDots);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-ptab]');
    if (tab) {
      var sec = tab.closest('[data-ptabs]');
      sec.querySelectorAll('[data-ptab]').forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
      });
      sec.querySelectorAll('[data-ppanel]').forEach(function (p) {
        p.hidden = p.dataset.ppanel !== tab.dataset.ptab;
        if (!p.hidden) buildDots(p);
      });
      return;
    }
    var nav = e.target.closest('[data-pnav]');
    if (nav) {
      var track = panelOf(nav).querySelector('[data-ptrack]');
      go(track, current(track) + (nav.dataset.pnav === 'next' ? 1 : -1));
      return;
    }
    var ing = e.target.closest('[data-pt-ing]');
    if (ing) {
      var modal = ing.closest('[data-ptabs]').querySelector('[data-pt-modal]');
      var tpl = ing.nextElementSibling;
      if (!modal || !tpl || !tpl.content) return;
      var body = modal.querySelector('[data-pt-modal-body]');
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
      return;
    }
    var modalEl = e.target.closest('[data-pt-modal]');
    if (modalEl && (e.target === modalEl || e.target.closest('[data-pt-close]'))) {
      if (modalEl.close) modalEl.close(); else modalEl.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ptab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[data-ptab]'));
    var next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    next.focus(); next.click();
  });

  var raf;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ptrack]')) return;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { buildDots(panelOf(t)); });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
